import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingCredentialsComponent } from './booking-credentials.component';
import { InputSelectModule } from '../input-select/input-select.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BookingCredentialsComponent],
  imports: [
    CommonModule,
    InputSelectModule,
    InputSubmitModule,
    InputFieldModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [BookingCredentialsComponent]
})
export class BookingCredentialsModule {}
